import { NavLink } from "react-router-dom";
import React, { useState } from "react";
import { useAppConfigContext } from "../context/AppConfigContext";

const ALL_PRODUCT_LINKS = [
  { label: "Pulo Assistant", to: "/travel-assistant", service: "puloAssistants" },
  { label: "Rides", to: "/rides", service: "rides" },
  { label: "Stays", to: "/stays", service: "stays" },
];

const otherLinkGroups = [
  {
    title: "Company",
    links: [
      { label: "Contact us", to: "/contact" },
      { label: "Help Center", to: "/help-center" },
      { label: "Blog", to: "/blog" },
      { label: "About us", to: "/about" },
    ],
  },
  {
    title: "Privacy",
    links: [
      { label: "Terms and condition", to: "/terms" },
      { label: "Privacy policy", to: "/privacy" },
    ],
  },
];

function Footer() {
  const currentYear = new Date().getFullYear();
  const { config, isServiceEnabled } = useAppConfigContext();
  const supportEmail = config.supportEmail;
  const linkGroups = [
    {
      title: "Products",
      links: ALL_PRODUCT_LINKS.filter((link) => isServiceEnabled(link.service)),
    },
    ...otherLinkGroups,
  ];
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = () => {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(supportEmail);
      setCopiedEmail(true);
      setTimeout(() => setCopiedEmail(false), 2000);
    }
  };

  return (
    <footer className="bg-white px-4 pb-24 pt-12 flex flex-col gap-16">
      <section className="max-sm:hidden w-full flex justify-center">
        <div className="w-full max-w-6xl lg:max-w-[80%] bg-[#f4f4f4a6] rounded-2xl px-6 py-12 md:px-16 text-center flex flex-col gap-6">
          <h2 className="text-[#570033] text-2xl md:text-3xl font-bold">
            Don’t be left out on our updates
          </h2>
          <p className="text-sm text-[#4f4f5a] font-medium">
            We send out updates to our weekly newsletter and we would love to
            keep you in the loop.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 items-center justify-center">
            <label htmlFor="footer-email" className="sr-only">
              Email Address
            </label>
            <input
              id="footer-email"
              type="email"
              placeholder="Enter email"
              className="w-full max-w-md rounded-lg border border-[#cfd2d9] bg-transparent px-4 py-3 text-base outline-none focus:border-[#7a0051]"
            />
            <button
              type="submit"
              className="px-8 py-[10px] rounded-lg bg-[#61013B] text-white text-lg font-medium hover:bg-[#5a003b] transition-colors"
            >
              Submit
            </button>
          </form>
        </div>
      </section>

      <section className="w-full sm:max-w-[81%] mx-auto flex max-lg:flex-col justify-between items-start gap-8 ">
        <div className="max-w-sm flex flex-col gap-2">
          <img src="/images/logo.png" alt="Pulo logo" className="w-28" />
          <p className="text-[#61013B] font-bold text-sm">
            Your Trusted Travel Companion
          </p>
          <p className="text-[#4f4f5a] text-sm leading-relaxed font-medium">
            Explore new destinations with ease—book rides, guides, and stays all
            in one app. Travel smarter, travel with Pulo.
          </p>
        </div>

        <div className="max-w-md grid  sm:grid-cols-3 gap-y-4 gap-x-6">
          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-[#570033] mb-3 font-semibold">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2 font-medium">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <NavLink
                      to={link.to}
                      className="text-[#4f4f5a] text-sm hover:text-[#7a0051]"
                    >
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a href=" https://www.instagram.com/pulo_hq?igsh=NHBxbmhlamw4YXdp">
            <img src="/icons/instagram.svg" alt="Instagram" className="w-7 h-7" />
          </a>
          <a href="https://www.linkedin.com/company/pulong/">
            <img src="/icons/linkedin.png" alt="LinkedIn" className="w-7 h-7" />
          </a>
          <a href="https://x.com/pulo_hq">
            <img src="/icons/twitter.svg" alt="Twitter" className="w-7 h-7" />
          </a>
          <button
            type="button"
            onClick={handleCopyEmail}
            title="Copy email"
            className="p-0 bg-transparent border-none"
          >
            <img src="/icons/mail.svg" alt="Email" className="w-7 h-7" />
          </button>
          {copiedEmail && (
            <span className="text-xs font-semibold text-[#570033]">Copied!</span>
          )}
          <a href="https://www.tiktok.com/@pulo_hq?_r=1&_t=ZS-91zhx2ufvj6">
            <img src="/icons/tiktok.png" alt="Facebook" className="w-6 h-6" />
          </a>
        </div>
      </section>

      <div className="sm:mx-auto">
        <p className="text-[#61013B] text-md">© Copyright {currentYear}.</p>
      </div>

      
    </footer>
  );
}

export default Footer;
